var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgTaxOpex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13211_25193)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92893 4.92889C7.96669 1.89113 12.4746 1.21498 16.1669 2.90619L16.9998 1.08786C12.5723 -0.940095 7.16247 -0.133077 3.51472 3.51468C-1.17157 8.20097 -1.17157 15.7989 3.51472 20.4852L4.92893 19.071C1.02369 15.1658 1.02369 8.83413 4.92893 4.92889ZM19.0711 4.92889C22.9763 8.83413 22.9763 15.1658 19.0711 19.071C16.0333 22.1088 11.5254 22.7849 7.8331 21.0937L7.00023 22.9121C11.4277 24.94 16.8375 24.133 20.4853 20.4852C25.1716 15.7989 25.1716 8.20097 20.4853 3.51468L19.0711 4.92889ZM16 9.99997V9.64275C16 7.80951 14.6164 6.71211 13 6.3734V5H11V6.33639C9.3836 6.61534 8 7.66225 8 9.49997C8 10.8262 8.84864 12.0036 10.1068 12.423L13.2607 13.4743C13.7022 13.6215 14 14.0346 14 14.5C14 16.2817 10 16.2684 10 14.3572V14H8V14.3572C8 16.2062 9.3836 17.3052 11 17.6409V19H13V17.6725C14.6164 17.3882 16 16.3352 16 14.5C16 13.1738 15.1514 11.9963 13.8932 11.5769L10.7393 10.5256C10.2978 10.3785 10 9.96532 10 9.49997C10 7.66192 14 7.80848 14 9.64275V9.99997H16Z",
    fill: "#55489E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13211_25193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxOpex);
export default __webpack_public_path__ + "static/media/tax-opex.927f20a0.svg";
export { ForwardRef as ReactComponent };